import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Button,
    Container,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Hidden,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
// 1. Import useLocation
import { Link, useLocation } from "react-router-dom";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { cssPaths } from "../../constants";
import { getQueryStringValue } from "../../utils/queryString";
import useQueryString from "../../hooks/useQueryString";


const useStyles = makeStyles((theme: Theme) =>
        createStyles({
                    Active: {
                        color: "rgb(7, 184, 248) !important",

                    },
                },
        ));
const Header: React.FC = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();
    const classes = useStyles();
    const urlToken = getQueryStringValue("token");
    const [token, setToken] = useQueryString("token", urlToken);
    const toggleDrawer = (open: boolean) => () => {
        setDrawerOpen(open);
    };
    const navItems = [
        { label: "Home", path: "/kaizen-iul" },
        { label: "How Kai-Zen Works", path: "/kaizen/how" },
        { label: "Performance Data", path: "/kaizen/performance" },
        { label: "FAQ", path: "/kaizen/faq" },
        { label: "Kai-Zen for Kids", path: "/kaizen/kids" },
        { label: "Estimate Benefits Start", path: "/kaizen/estimate-benefits" },
        { label: "Enrollment Start", path: `/accept/invitation/${token}` },
    ];
    return (
            <>
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL + cssPaths.newThemeCss}`}/>;

            <AppBar position="sticky" color="inherit" elevation={0}>
                <Container maxWidth="xl">
                    <Toolbar style={{ justifyContent: "center" }}>
                        {/* Desktop Menu */}
                        <Hidden smDown>
                            <div>
                                {navItems.map((item) => (
                                        <Button
                                                key={item.label}
                                                // Conditionally change color for active desktop button
                                                className={location.pathname === item.path ? classes.Active : " "}
                                                style={{ margin: "0 8px" }}
                                                component={Link}
                                                to={`${item.path + `?token=${token}`}`}
                                        >
                                            <strong className="f18">{item.label}</strong>
                                        </Button>
                                ))}
                            </div>
                        </Hidden>

                        {/* Mobile Menu Icon */}
                        <Hidden mdUp>
                            <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)}>
                                <MenuIcon />
                            </IconButton>
                        </Hidden>
                    </Toolbar>
                </Container>

                {/* Mobile Drawer */}
                <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                    <List style={{ width: 250 }}>
                        {navItems.map((item) => (
                                <ListItem
                                        button
                                        key={item.label}
                                        component={Link}
                                        to={item.path}
                                        onClick={toggleDrawer(false)}
                                        // 3. Add the 'selected' prop based on the current path
                                        selected={location.pathname === item.path}
                                >
                                    <ListItemText primary={item.label} />
                                </ListItem>
                        ))}
                    </List>
                </Drawer>
            </AppBar>
                </>
    );
};

export default Header;